import { ResourceAttributeValueDto } from "./resource-attribute-definition";

export class AttributeValue {
    public attributeDefinitionId: number;       
    public value: object;
  
    static toDto(entity: AttributeValue): ResourceAttributeValueDto {
      let dto = new ResourceAttributeValueDto();
      dto.attributeDefinitionId = entity.attributeDefinitionId;
      dto.value = entity.value;
      return dto;
    }
  
    static fromDto(dto: ResourceAttributeValueDto): AttributeValue {
      let entity = new AttributeValue();
      entity.attributeDefinitionId = dto.attributeDefinitionId;
      entity.value = dto.value;
      return entity;
    }
  }